import { render, staticRenderFns } from "./campus-upload-applicants.vue?vue&type=template&id=4a1a82f1&scoped=true"
import script from "./campus-upload-applicants.vue?vue&type=script&lang=js"
export * from "./campus-upload-applicants.vue?vue&type=script&lang=js"
import style0 from "./campus-upload-applicants.vue?vue&type=style&index=0&id=4a1a82f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a82f1",
  null
  
)

export default component.exports